import { defineComponent, Component as VueComponent, h } from 'vue';

export default function withPropsInjected(Component: VueComponent, props: object) {
    // PRODUCT-26110 Phase 2B2 Task 5 batch 5: `Vue.component(name, {...})` is Vue 2's
    // global-registration API (removed from Vue 3's own types, TS2339, since bare
    // `import Vue from 'vue'` has none of the compat-mode global-API statics) -- but
    // this call's registered string name ('withPropsInjected') is never referenced
    // anywhere (confirmed by grep across every call site: the return value is always
    // consumed directly as a component/HOC, never resolved by name), matching Task 4
    // bucket 1's identical finding for the 4 HOC decorators there. `defineComponent`
    // is the direct Vue 3 replacement for the definition-object builder role this was
    // actually playing.
    return defineComponent({
        // eslint-disable-next-line
        // @ts-ignore: use internal prop types
        props: Component.options?.props,
        render() {
            // Vue 3: h() takes flat props (no more nested props/on/attrs sub-objects).
            // $attrs already carries fallthrough event listeners as onXxx keys (no
            // separate $listeners concept), and scopedSlots/$slots are unified -- $slots
            // covers both in Vue 3.
            return h(Component, { ...this.$attrs, ...this.$props, ...props }, this.$slots);
        },
    });
}
